var Glyphicon = require("components/utility/icons/Glyphicon");

require("data/goal_dates_warning.scss");

class GoalDatesWarning extends React.Component {
    constructor(props) {
        super();
        autobind(this);
    }



    // Checks if a single entity is outdated
    checkIfEntityHasOutdatedDates(entity){
		if (_.include([$wr.Constants.PERIODS.MONTH,$wr.Constants.PERIODS.WEEK],entity.prefs.expectations_time_period)){ return false }
		
		var periodStarts = entity.prefs.expectations_time_period_starts
		var lastPeriodStart = new Date(periodStarts[periodStarts.length - 1])

		var lastPeriodEndMonth = entity.prefs.school_year_end_month

		if (lastPeriodStart.getMonth() < lastPeriodEndMonth){
			var year = lastPeriodStart.getFullYear()
		} else {
			var year = lastPeriodStart.getFullYear() + 1
		}

		var lastPeriodEnd = new Date(year, lastPeriodEndMonth)
		
		return new Date() > lastPeriodEnd
	}

    // checks for an admin and their sls
	adminAccountHasOutdatedDates(user, studentLists){
		
		var adminDatesProblem = this.checkIfEntityHasOutdatedDates(user)
		var studentListDatesProblem = false

		if (studentLists){
			studentLists.forEach(sl=>{
				if (this.checkIfEntityHasOutdatedDates(sl)){
					studentListDatesProblem = true	
				}
			})
		}

		return adminDatesProblem || studentListDatesProblem
	}


  
    render() {
        var studentLists = this.props.studentLists || []
        if (this.adminAccountHasOutdatedDates(this.props.user, studentLists)){
            return (
                <div className='GoalDatesWarning'> 
                    <Glyphicon icon="glyphicon glyphicon-exclamation-sign" className='exclam'/>
                    <i> Some of your classes have outdated goal period dates from previous school years. This may cause issues with goal tracking. Change your class-level dates on the <a onClick={()=>$wr.redirect("roster")}>roster page</a>, or change your account-level dates in your <a onClick={()=>$wr.redirect("settings/general_org_settings")}>settings.</a></i>
                </div>
            )
        } else {
            return null
        }
    }
}

module.exports = GoalDatesWarning;



// WEBPACK FOOTER //
// ./modules/components/notifications/GoalDatesWarning.js